const requiredMethods = [
  "createUpload",
  "uploadToR2",
  "createJob",
  "getJob",
  "getTranscript",
  "deleteJob",
  "getQuota",
];

function assertFunction(methods, key) {
  if (typeof methods[key] !== "function") {
    throw new TypeError(`backend adapter missing ${key}()`);
  }
}

export function createBackendAdapter(methods = {}) {
  requiredMethods.forEach((key) => assertFunction(methods, key));
  return {
    createUpload: methods.createUpload,
    uploadToR2: methods.uploadToR2,
    createJob: methods.createJob,
    getJob: methods.getJob,
    getTranscript: methods.getTranscript,
    deleteJob: methods.deleteJob,
    getQuota: methods.getQuota,
  };
}

export function describeBackendAdapter() {
  return {
    createUpload:
      "createUpload({ filename, size_bytes, mime_type }) => upload session",
    uploadToR2:
      "uploadToR2({ upload_url, file, onProgress }) => upload completion",
    createJob: "createJob({ media_r2_key, mode, async }) => job",
    getJob: "getJob(jobId) => job",
    getTranscript: "getTranscript(jobId) => transcript text",
  };
}
